import { host } from '../config';

const getToken = () => {
  const auth = JSON.parse(sessionStorage.getItem('auth'));
  return auth.token;
};

// application/vnd.ms-excel
// application/pdf

// JSON headers
export const getHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: `Token ${getToken()}`,
});

export const getNonJsonHeaders = (accept = 'application/json') => ({
  Accept: accept,
  Authorization: `Token ${getToken()}`,
});
export const getNoAuthHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
});

export function fetchHotels() {
  return fetch(`${host}/api/property/hotel/?managed=true`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchTours() {
  return fetch(`${host}/api/tour/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchTour(id) {
  return fetch(`${host}/api/tour/${id}/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function changePin(payload,id) {
  return fetch(`${host}/api/tour/${id}/change_tour_pin/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function fetchQuestion() {
  return fetch(`${host}/api/question/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchTourQuestion(id) {
  return fetch(`${host}/api/question/${id}/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function createQuestion(payload) {
  return fetch(`${host}/api/question/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function deleteQuestion(id) {
  return fetch(`${host}/api/question/${id}/delete_question/`,{
    headers: getHeaders(),
    method: 'DELETE',
  });
}

export function addQuestion(payload) {
  return fetch(`${host}/api/addquestion/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function deleteAddedQuestion(id,param) {
  let payload ={
    question_id:id,
    group_id:param.group_id
  };
  return fetch(`${host}/api/addquestion/${id}/delete_addedquestion/`,{
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchAddedQuestions(id) {
  return fetch(`${host}/api/addquestion/${id}/`,{
    headers: getHeaders(),
    method: 'GET',
  });
}

export function createAnswers(payload) {
  return fetch(`${host}/api/answers/update_answers/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchAnswers (id) {
  return fetch(`${host}/api/answers/${id}/`,{
    headers: getHeaders(),
    method: 'GET',
  });
}

export function addGroup(payload) {
  return fetch(`${host}/api/group/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function addNewRoomType(payload){
  return fetch(`${host}/api/room_type/`,{
    headers:getHeaders(),
    method:'POST',
    body:JSON.stringify(payload),
  });
}

export function fetchRoomType(){
  return fetch(`${host}/api/room_type/`,{
    headers:getHeaders(),
    method:'GET',
  });
}

export function removeMemberFromGroup(groupId, payload) {
  return fetch(`${host}/api/group/${groupId}/remove_member/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function deleteGroup(id) {
  return fetch(`${host}/api/group/${id}/`, {
    headers: getHeaders(),
    method: 'DELETE',
  });
}
export function deleteEvent(id, param) {
  let payload = {
    id: id,
    isCalledFromCancel: param.isCalledFromCancelFlag,
    event_type: param.event_type
  };

  return fetch(`${host}/api/event/${id}/delete_event/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function addHotel(eventId, payload) {
  return fetch(`${host}/api/bidset/${eventId}/add_hotel/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function addHotelFromWeb(eventId, payload) {
  return fetch(`${host}/api/bidset/${eventId}/add_hotel_from_web/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function createMember(payload) {
  return fetch(`${host}/api/member/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function createMembers(payload) {
  //debugger
  return fetch(`${host}/api/member/create_members/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function addRoomType(payload) {
  //debugger
  return fetch(`${host}/api/member/add_roomType/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function addGroupData(payload) {
  //debugger
  return fetch(`${host}/api/member/save_groupData/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function addBulkGroupData(payload) {
  return fetch(`${host}/api/member/save_bulk_groupData/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function addBidDetails(payload) {
  //debugger
  return fetch(`${host}/api/bid/save_biddetails/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function addParticipant(payload) {
  return fetch(`${host}/api/bid/add_participant/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function saveAddBookingDetails(payload) {  
  return fetch(`${host}/api/bid/save_add_booking_data/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function addMultipleBidDetailRecords(payload) {
  return fetch(`${host}/api/bid/save_multi_biddetails/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function changeMembersDates(payload) {
  return fetch(`${host}/api/bid/change_bulk_dates/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function patchMember(id, payload) {

  return fetch(`${host}/api/member/${id}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}
export function patchBidset(eventId, payload) {
  return fetch(`${host}/api/bidset/${eventId}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}
export function patchBid(bidId, payload) {
  return fetch(`${host}/api/bid/${bidId}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}
export function deleteBid(bidId) {
  return fetch(`${host}/api/bid/${bidId}/`, {
    headers: getHeaders(),
    method: 'DELETE',
  });
}
export function postUpdateReOpenBid(payload) {
  return fetch(`${host}/api/bid/update_to_reopenbid/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function postUpdateBids(payload) {
  return fetch(`${host}/api/bid/send_update/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function fetchAddBidNote(id, payload) {
  return fetch(`${host}/api/bid/${id}/add_note/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function setFavoriteHotel(hotelId, payload) {
  return fetch(`${host}/api/hotel/${hotelId}/favorite/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchFindHotels(eventId, name) {
  return fetch(`${host}/api/hotel_search/?event=${eventId}&name=${name}`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchSearchHotels(eventId) {
  return fetch(`${host}/api/bidset/${eventId}/search_hotel/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function updateBrandContact(proposalId, payload){
  return fetch(`${host}/api/proposal/${proposalId}/update_contact/`,{
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function deleteBrandContact(proposalId, payload){
  return fetch(`${host}/api/proposal/${proposalId}/delete_contact/`,{
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function updateProposal(proposalId, payload) {
  return fetch(`${host}/api/proposal/${proposalId}/send/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchAddBrandContact(proposalId, payload) {
  return fetch(`${host}/api/proposal/${proposalId}/add_brand_contact/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchSendBid(bidId, payload) {
  return fetch(`${host}/api/bid/${bidId}/send/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function deleteHotelContact(bidId,payload){
  return fetch(`${host}/api/bid/${bidId}/delete_hotel_contact/`,{
    headers:getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function updateHotelContact(bidId,payload){
  return fetch(`${host}/api/bid/${bidId}/update_hotel_contact/`,{
    headers:getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchAddHotelContact(bidId, payload) {
  return fetch(`${host}/api/bid/${bidId}/add_hotel_contact/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchSendBidRequests(payload) {
  return fetch(`${host}/api/bid/send_hotel_bids/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchBidsets(tourId) {
  const saveUrl = `${host}/api/bid/?tour_id=${tourId}`;
  return fetch(saveUrl, {
    method: 'GET',
    headers: getHeaders(),
  });
}
export function fetchProposal(tourId) {
  const saveUrl = `${host}/api/proposal/?tour_id=${tourId}`;
  return fetch(saveUrl, {
    method: 'GET',
    headers: getHeaders(),
  });
}
export function createEvent(payload) {
  return fetch(`${host}/api/event/`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
}
export function patchEvent(id, payload) {
  const saveUrl = `${host}/api/event/${id}/`;
  return fetch(saveUrl, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
}
export function updateEvent(id, payload) {
  const saveUrl = `${host}/api/event/${id}/update_event/`;
  return fetch(saveUrl, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
}
export function patchGroup(id, payload) {
  const saveUrl = `${host}/api/group/${id}/`;
  return fetch(saveUrl, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
}
export function patchGroupEvent(id, payload) {
  const saveUrl = `${host}/api/group_event/${id}/`;
  return fetch(saveUrl, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
}
export function patchPreferences(prefId, payload) {
  const saveUrl = `${host}/api/preference/${prefId}/`;
  return fetch(saveUrl, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
}
export function sendCityNotes(payload){
  const saveUrl = `${host}/api/citynotes/`;
  return fetch(saveUrl,{
    method:'POST',
    headers:getHeaders(),
    body:JSON.stringify(payload),
  })
}

export function DeleteNotes(id){
  const Url= `${host}/api/citynotes/${id}/`;
  return fetch(Url,{
    method:'DELETE',
    headers:getHeaders()
  })
}
export function patchTour(id, payload) {
  const saveUrl = `${host}/api/tour/${id}/`;
  return fetch(saveUrl, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
}
export function postClearRoute(id, payload) {
  const url = `${host}/api/tour/${id}/clear_route/`;
  return fetch(url, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
}
export function clearTourRoster(id, payload) {
  const url = `${host}/api/tour/${id}/clear_roster/`;
  return fetch(url, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
}

export function fetchTourDownload(id, payload) {
  return fetch(`${host}/api/tour/${id}/download/?report=${payload.report}`, {
    headers: getNonJsonHeaders(payload.format),
    method: 'GET',
  });
}

export function fetchSendToTour(id, payload) {
  return fetch(`${host}/api/tour/${id}/send_to_manager/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchRemoveTourManager(id, payload) {
  return fetch(`${host}/api/tour/${id}/remove_manager/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function fetchBrands() {
  return fetch(`${host}/api/brand/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchBrandGroups() {
  return fetch(`${host}/api/brandgroups/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchPlaces() {
  return fetch(`${host}/api/place/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchAddTour(payload) {
  return fetch(`${host}/api/tour/`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
}

export function registerUser(payload) {
  return fetch(`${host}/api/register/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchRegisterAgency(payload) {
  return fetch(`${host}/api/register/agency/`, {
    headers: getNoAuthHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchImportRouteStatus(id) {
  return fetch(`${host}/api/tour/${id}/import_route_status/`, {
    method: 'GET',
    headers: getHeaders(),
  });
}
export function uploadTourImage(id, acceptedFiles) {
  const formData = new FormData();
  formData.append('image', acceptedFiles[0]);
  return fetch(`${host}/api/tour/${id}/`, {
    method: 'PATCH',
    headers: getNonJsonHeaders(),
    body: formData,
  });
}

export function uploadRoute(id, acceptedFiles) {
  const formData = new FormData();
  for (name in acceptedFiles) {
    formData.append('import_file', acceptedFiles[name], name);
  }
  console.log('form Data is ', formData);
  return fetch(`${host}/api/tour/${id}/import_route/`, {
    method: 'POST',
    headers: getNonJsonHeaders(),
    body: formData,
  });
}

export function uploadRoster(id, acceptedFiles) {
  console.log('uploadRoster form Data is ', id, acceptedFiles);
  const formData = new FormData();
  for (name in acceptedFiles) {
    formData.append('import_file', acceptedFiles[name], name);
  }
  return fetch(`${host}/api/tour/${id}/import_members/`, {
    method: 'POST',
    headers: getNonJsonHeaders(),
    body: formData,
  });
}

export function fetchCommissions(page, column_name, filter_by_currency) {
  const limit = 100
  const offset = page
  return fetch(`${host}/api/commission/?order_by=${column_name}&filter_by_currency=${filter_by_currency}`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchCommissionsList(id,payload) {
  return fetch(`${host}/api/commission/${id}/getcommissiondata/?report=${payload.report}`, {
    headers: getNonJsonHeaders(payload.format),
    method: 'GET',
  });
}

export function fetchCommissionInvoice(id, payload) {
  return fetch(`${host}/api/commission/${id}/download_commission_invoice/?report=${payload.report}&bid_id=${id}`, {
    headers: getNonJsonHeaders(payload.format),
    method: 'GET',
  });
}

export function fetchCommissionsOverview(page, filter_by_currency) {
  const limit = 10
  const offset = page * 10
  return fetch(`${host}/api/commission/getcommissionoverview?filter_by_currency=${filter_by_currency}`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function patchCommission(payload) {
  return fetch(`${host}/api/commission/mark_as_paid/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function deleteCommision(payload) {
  return fetch(`${host}/api/commission/delete_commission/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchProfiles() {
  return fetch(`${host}/api/profile/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}


export const eventTypes = {
  DR: 'Draft',
  UK: 'Unsent',
  SG: 'Sending',
  ST: 'Sent',
  UR: 'Unread',
  VW: 'Viewed',
  RE: 'Replied',
  PD: 'Pending',
  SO: 'Soldout',
  IN: 'Interested',
  DE: 'Decline',
  DD: 'Declined',
  EX: 'Expired',
  AC: 'Accept',
  AD: 'Accepted',
  CA: 'Cancel',
  CD: 'Cancelled',
  CP: 'Contract Pending',
  CO: 'Contracted',
};

export const bidStates = {
  DR: 'Draft',
  UK: 'Unsent',
  SG: 'Sending',
  ST: 'Sent',
  UR: 'Unread',
  VW: 'Viewed',
  RE: 'Replied',
  PD: 'Responded',
  SO: 'Soldout',
  IN: 'Interested',
  DE: 'Decline',
  DD: 'Declined',
  EX: 'Expired',
  AC: 'Accept',
  AD: 'Accepted',
  CA: 'Cancel',
  CD: 'Cancelled',
  CP: 'Contract Pending',
  CO: 'Contracted',
  PB: 'Prebooked',
  SC: 'Stay Cancelled',
  SU: 'Stay Updated'
};
export const acceptedStates = ['AC', 'AD', 'CP', 'CO', 'PB'];
export const pendingStates = ['RE', 'IN'];

export function displayBuyerBidState(buyerState, bidderState) {
  if (['DR', 'PD', 'DE', 'CD'].includes(buyerState)) {
    return bidStates[buyerState];
  }
  return bidStates[buyerState];
}

export function displayBidderBidState(buyerState, bidderState) {
  return bidStates[bidderState];
}

export function fetchTourManagers() {
  const auth = JSON.parse(sessionStorage.getItem('auth'));
  const id = auth.profile.user.id;
  return fetch(`${host}/api/agency/${id}/get_travel_managers/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchNotifications() {
  return fetch(`${host}/api/bidNotification/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function deleteNotifications(id) {
  return fetch(`${host}/api/bidNotification/${id}/`, {
    headers: getHeaders(),
    method: 'DELETE',
  });
}

export function readNotifications(payload) {
  return fetch(`${host}/api/bidNotification/markasread/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function getBidDetails(bid) {
  console.log(host)
  return fetch(`${host}/api/biddetails/?bid=${bid}`, {
    headers: getHeaders(),
    method: 'GET',
  });
}


export function getCompareBidsDetails(tourId, parentId) {
  console.log(host)
  return fetch(`${host}/api/comparebids/?tour_id=${tourId}&parent_id=${parentId}`, {
    headers: getHeaders(),
    method: 'GET',
  });
}




// WEBPACK FOOTER //
// src/core/api.js